import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getTemplates = createAsyncThunk("template/getTemplates", async (payload) => {
  try {
    const response = await magnifiAPI.getTemplates(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const addMediaTemplate = createAsyncThunk("template/addMediaTemplate", async (payload) => {
  try {
    const response = await magnifiAPI.addMediaTemplate(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const editMediaTemplate = createAsyncThunk("template/editMediaTemplate", async (payload) => {
  try {
    const response = await magnifiAPI.editMediaTemplate(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteMediaTemplate = createAsyncThunk("template/deleteMediaTemplate", async (payload) => {
  try {
    const response = await magnifiAPI.deleteMediaTemplate(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
